// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   CardMedia,
//   CardActions,
//   Button,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   CircularProgress,
//   Pagination,
//   Alert,
//   Chip,
// } from "@mui/material";
// import { Delete, Edit, Visibility, ThumbUp } from "@mui/icons-material";
// import { getMyShorts, deleteShort, updateShort } from "../../../services/adminService"; // Adjust path

// const MyShortsList = () => {
//   const [shorts, setShorts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   // Edit Modal State
//   const [openEdit, setOpenEdit] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [updating, setUpdating] = useState(false);

//   // Fetch Shorts
//   const fetchShorts = async () => {
//     setLoading(true);
//     try {
//       const res = await getMyShorts(page, 10); // Page, Limit
//       setShorts(res.data || []);
//       setTotalPages(res.totalPages || 1);
//     } catch (err) {
//       setError("Failed to load shorts.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchShorts();
//   }, [page]);

//   // Handle Delete
//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this short?")) return;
//     try {
//       await deleteShort(id);
//       setShorts(shorts.filter((short) => short._id !== id)); // UI Update
//     } catch (err) {
//       alert(err.message || "Failed to delete");
//     }
//   };

//   // Open Edit Modal
//   const handleEditClick = (short) => {
//     setEditData({
//       id: short._id,
//       title: short.title,
//       description: short.description,
//       // Add other fields if you want to edit category/location logic here
//       videoFile: null, // For new upload
//     });
//     setOpenEdit(true);
//   };

//   // Handle Update Submit
//   const handleUpdateSubmit = async () => {
//     if (!editData.title) return alert("Title is required");
    
//     setUpdating(true);
//     try {
//       const formData = new FormData();
//       formData.append("title", editData.title);
//       formData.append("description", editData.description);
      
//       // Only append video if user selected a new one
//       if (editData.videoFile) {
//         formData.append("video", editData.videoFile);
//       }

//       const res = await updateShort(editData.id, formData);
      
//       // Update local state to reflect changes immediately
//       setShorts(shorts.map(s => s._id === editData.id ? { ...s, ...res.data } : s));
      
//       setOpenEdit(false);
//       alert("Short updated successfully!");
//     } catch (err) {
//       alert(err.message || "Update failed");
//     } finally {
//       setUpdating(false);
//     }
//   };

//   return (
//     <Box sx={{ p: 4, maxWidth: 1200, mx: "auto" }}>
//       <Typography variant="h4" gutterBottom fontWeight="bold">
//         My Shorts
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

//       {loading ? (
//         <Box display="flex" justifyContent="center" mt={4}>
//           <CircularProgress />
//         </Box>
//       ) : (
//         <>
//           <Grid container spacing={3}>
//             {shorts.length === 0 ? (
//                <Typography variant="body1" sx={{ mt: 2, ml: 3 }}>No shorts found.</Typography>
//             ) : (
//               shorts.map((short) => (
//                 <Grid item xs={12} sm={6} md={4} key={short._id}>
//                   <Card sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: 3, boxShadow: 3 }}>
                    
//                     {/* Thumbnail / Video Preview */}
//                     <Box sx={{ position: "relative", height: 200, bgcolor: "#000" }}>
//                       {short.thumbnailUrl ? (
//                          <CardMedia component="img" height="200" image={short.thumbnailUrl} alt={short.title} />
//                       ) : (
//                         <CardMedia component="video" height="200" src={short.videoUrl} controls sx={{ objectFit: "contain" }} />
//                       )}
                      
//                       {/* Status Badge */}
//                       <Chip 
//                         label={short.status} 
//                         color={short.status === 'published' ? 'success' : short.status === 'rejected' ? 'error' : 'warning'}
//                         size="small"
//                         sx={{ position: "absolute", top: 10, right: 10, textTransform: "capitalize" }}
//                       />
//                     </Box>

//                     <CardContent sx={{ flexGrow: 1 }}>
//                       <Typography variant="h6" noWrap title={short.title}>
//                         {short.title}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                         {new Date(short.createdAt).toLocaleDateString()}
//                       </Typography>
                      
//                       <Box display="flex" gap={2} alignItems="center" mb={1}>
//                         <Box display="flex" alignItems="center" gap={0.5}>
//                             <Visibility fontSize="small" color="action" />
//                             <Typography variant="caption">{short.viewsCount || 0}</Typography>
//                         </Box>
//                         <Box display="flex" alignItems="center" gap={0.5}>
//                             <ThumbUp fontSize="small" color="action" />
//                             <Typography variant="caption">{short.likes?.length || 0}</Typography>
//                         </Box>
//                       </Box>

//                       <Typography variant="body2" color="text.secondary" noWrap>
//                          {short.description || "No description"}
//                       </Typography>
//                     </CardContent>

//                     <CardActions sx={{ justifyContent: "space-between", p: 2 }}>
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         startIcon={<Edit />} 
//                         onClick={() => handleEditClick(short)}
//                       >
//                         Edit
//                       </Button>
//                       <Button 
//                         size="small" 
//                         variant="contained" 
//                         color="error" 
//                         startIcon={<Delete />} 
//                         onClick={() => handleDelete(short._id)}
//                       >
//                         Delete
//                       </Button>
//                     </CardActions>
//                   </Card>
//                 </Grid>
//               ))
//             )}
//           </Grid>

//           {/* Pagination */}
//           <Box display="flex" justifyContent="center" mt={4}>
//             <Pagination 
//               count={totalPages} 
//               page={page} 
//               onChange={(e, val) => setPage(val)} 
//               color="primary" 
//             />
//           </Box>
//         </>
//       )}

//       {/* Edit Dialog */}
//       <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
//         <DialogTitle>Edit Short</DialogTitle>
//         <DialogContent dividers>
//           {editData && (
//             <Box component="form" noValidate>
//               <TextField
//                 margin="normal"
//                 label="Title"
//                 fullWidth
//                 value={editData.title}
//                 onChange={(e) => setEditData({ ...editData, title: e.target.value })}
//               />
//               <TextField
//                 margin="normal"
//                 label="Description"
//                 fullWidth
//                 multiline
//                 rows={3}
//                 value={editData.description}
//                 onChange={(e) => setEditData({ ...editData, description: e.target.value })}
//               />
              
//               <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>Update Video (Optional)</Typography>
//               <Button variant="outlined" component="label" fullWidth>
//                 {editData.videoFile ? editData.videoFile.name : "Choose New Video File"}
//                 <input 
//                   type="file" 
//                   hidden 
//                   accept="video/*" 
//                   onChange={(e) => setEditData({ ...editData, videoFile: e.target.files[0] })} 
//                 />
//               </Button>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenEdit(false)} disabled={updating}>Cancel</Button>
//           <Button onClick={handleUpdateSubmit} variant="contained" disabled={updating}>
//             {updating ? "Updating..." : "Save Changes"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default MyShortsList;


import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Pagination,
  CircularProgress,
} from "@mui/material";

import { Edit, Delete, Visibility, ThumbUp } from "@mui/icons-material";
import { getMyShorts, deleteShort, updateShort } from "../../../services/adminService";

const MyShortsList = () => {
  const [shorts, setShorts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [updating, setUpdating] = useState(false);

  const fetchShorts = async () => {
    setLoading(true);
    try {
      const res = await getMyShorts(page, 10);
      setShorts(res.data || []);
      setTotalPages(res.totalPages || 1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShorts();
  }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this short?")) return;
    await deleteShort(id);
    setShorts(shorts.filter((s) => s._id !== id));
  };

  const handleEditClick = (short) => {
    setEditData({
      id: short._id,
      title: short.title,
      description: short.description,
      videoFile: null,
    });
    setOpenEdit(true);
  };

  const handleUpdateSubmit = async () => {
    setUpdating(true);

    const fd = new FormData();
    fd.append("title", editData.title);
    fd.append("description", editData.description);
    if (editData.videoFile) fd.append("video", editData.videoFile);

    const res = await updateShort(editData.id, fd);

    setShorts(shorts.map((x) => (x._id === editData.id ? { ...x, ...res.data } : x)));
    setOpenEdit(false);
    setUpdating(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" fontWeight="bold" mb={3}>
        My Shorts
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={5}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} elevation={3}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                 <TableCell >#No</TableCell>
                <TableCell width={120}>Preview</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Status</TableCell>
                {/* <TableCell>Views</TableCell> */}
                <TableCell>Likes</TableCell>
                <TableCell>Date</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {shorts.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No Shorts Found
                  </TableCell>
                </TableRow>
              ) : (
                shorts.map((row,index) => (
                  <TableRow key={row._id} hover>
                    {/* Auto Play Video */}
                     <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <video
                        src={row.videoUrl}
                        width="110"
                        height="150"
                        muted
                        loop
                        autoPlay
                        style={{
                          borderRadius: 8,
                          objectFit: "cover",
                        }}
                      />
                    </TableCell>

                    <TableCell sx={{ fontWeight: 600 }}>{row.title}</TableCell>

                    <TableCell sx={{ maxWidth: 200 }} title={row.description}>
                      {row.description?.slice(0, 40)}...
                    </TableCell>

                    <TableCell>
                      <Chip
                        label={row.status}
                        color={
                          row.status === "published"
                            ? "success"
                            : row.status === "rejected"
                            ? "error"
                            : "warning"
                        }
                        size="small"
                        sx={{ textTransform: "capitalize" }}
                      />
                    </TableCell>

                    {/* <TableCell>
                      <Visibility fontSize="small" /> {row.viewsCount || 0}
                    </TableCell> */}

                    <TableCell>
                      <ThumbUp fontSize="small" /> {row.likes?.length || 0}
                    </TableCell>

                    <TableCell>
                      {new Date(row.createdAt).toLocaleDateString()}
                    </TableCell>

                    <TableCell align="right">
                      {/* <Button
                        size="small"
                        variant="outlined"
                        startIcon={<Edit />}
                        onClick={() => handleEditClick(row)}
                        sx={{ mr: 1 }}
                      >
                        Edit
                      </Button> */}
                      <Button
                        size="small"
                        variant="contained"
                        color="error"
                        startIcon={<Delete />}
                        onClick={() => handleDelete(row._id)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Pagination */}
      <Box display="flex" justifyContent="center" mt={3}>
        <Pagination count={totalPages} page={page} onChange={(e, v) => setPage(v)} />
      </Box>

      {/* Edit Dialog */}
      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
        <DialogTitle>Edit Short</DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Title"
            fullWidth
            sx={{ my: 1 }}
            value={editData?.title || ""}
            onChange={(e) => setEditData({ ...editData, title: e.target.value })}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={3}
            sx={{ my: 1 }}
            value={editData?.description || ""}
            onChange={(e) =>
              setEditData({ ...editData, description: e.target.value })
            }
          />

          <Button component="label" variant="outlined" sx={{ mt: 2 }}>
            {editData?.videoFile ? editData.videoFile.name : "Choose New Video"}
            <input
              hidden
              type="file"
              accept="video/*"
              onChange={(e) =>
                setEditData({ ...editData, videoFile: e.target.files[0] })
              }
            />
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEdit(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleUpdateSubmit}>
            {updating ? "Updating..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MyShortsList;
